import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { AbstractControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbOptionModule } from 'mdb-angular-ui-kit/option';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { TranslateModule } from '@ngx-translate/core';
import { MdbValidationModule } from 'mdb-angular-ui-kit/validation';
import { SelectorModel } from '../../../models/table-column.model';

@Component({
  selector: 'app-form-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MdbFormsModule,
    MdbOptionModule,
    MdbSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    MdbValidationModule,
  ],
  templateUrl: './form-select.component.html',
  standalone: true,
  styles: '',
})
export class FormSelectComponent {
  id = input.required<string>();
  label = input.required<string>();
  hideLabel = input(false);
  controlName = input.required<string>();
  formGroup = input.required<FormGroup>();
  isRequired = input(false);
  options = input.required<any[] | undefined>();
  optionLabelSelector = input.required<SelectorModel[]>();
  filter = input(false);
  multiple = input(false);
  clear = input(false);
  optionValueSelector = input<string | undefined>();
  placeholder = input<string>();
  translateOptionLabels = input<boolean>(false);
  loading = input<boolean>(false);

  /** Emitted when user types in the filter (search) field. Use for async option loading. */
  search = output<string>();
  /** Emitted when the dropdown opens. Use to load initial options for async search. */
  opened = output<void>();

  getOptionLabel(data: any) {
    let result = '';
    this.optionLabelSelector().forEach((s: SelectorModel) => {
      let splits = s.selector.split('.');
      let selectorResult = data;
      splits.forEach((sp) => {
        selectorResult = selectorResult[sp];
      });

      result += selectorResult;
      if (s.suffix) result += s.suffix;
    });
    return result;
  }

  get control(): AbstractControl | null {
    return this.formGroup().get(this.controlName());
  }

  getOptionValue(data: any): any {
    let splits = this.optionValueSelector()!.split('.');
    let valueResult = data;
    splits.forEach((sp) => {
      valueResult = valueResult ? valueResult[sp] : null;
    });
    return valueResult;
  }
}
